<template>
  <SearchYouthDetail v-if="['star', 'show', 'achievement'].indexOf(subpath) !== -1 && detail !== ''" :popInKr="true" :subpath="subpath" :detail="detail"/>
  <SearchEduCompanyDetail v-else-if="['edu', 'station', 'exam', 'company'].indexOf(subpath) !== -1 && detail !== ''" :popInKr="true" :subpath="subpath" :detail="detail"/>
  <div v-else-if="detail === ''" :class="isPC ? 'content-area' : 'm-content-area'">
    <div :class="isPC ? 'list-wrapper' : 'm-list-wrapper'">
      <h3>搜索结果</h3>
      <div v-for="item of dataList" :key="item.boothNo" class="list-item">
        <p class="item-des" @click="showDetail(item)">{{item.worksName || item.companyName}}</p>
      </div>
      <Pagination v-if="isPC" :total='total' :currentPage="currentPage" :pageSize="pageSize" @pageChange="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from '@/common/Pagination'
import SearchEduCompanyDetail from '@/common/SearchEduCompanyDetail'
import SearchYouthDetail from '@/common/SearchYouthDetail'
export default {
  name: 'SearchPage',
  components: { Pagination, SearchEduCompanyDetail, SearchYouthDetail },
  props: ['popInKr', 'searchItem'],
  data () {
    return {
      subpath: '',
      detail: '',

      currentPage: 1,
      pageSize: 8,
      total: 0,
      totalDataList: [],
      dataList: []
    }
  },
  mounted() {
    this.dataList = []
    this.totalDataList = []
    this.currentPage = 1
    this.getData(this.searchItem)
  },
  methods: {
    getData (query) {
      let data = this.$allData[this.currentLang] || []
      let showDataList = []
      for (let item of data) {
        if ((item.worksName && item.worksName.indexOf(query) >= 0) || (item.companyName && item.companyName.indexOf(query) >= 0)) {
          // 作品名，单位名
          showDataList.push(item)
        } else if ((item.creatorName && item.creatorName.indexOf(query) >= 0) || (item.school && item.school.indexOf(query) >= 0)) {
          // 作者名 学校
          showDataList.push(item)
        } else if ((item.countryRegion && item.countryRegion.indexOf(query) >= 0) || (item.provinceCity && item.provinceCity.indexOf(query) >= 0)) {
          // 国家，地区
          showDataList.push(item)
        } else if (item.boothNo && item.boothNo.indexOf(query) >= 0) {
          // 展位号
          showDataList.push(item)
        } else if ((item.workIntroductin && item.workIntroductin.indexOf(query) >= 0) || (item.companyDesc && item.companyDesc >= 0)) {
          // 作品 企业简介
          showDataList.push(item)
        }
      }
      this.totalDataList = showDataList
      this.total = showDataList.length
      // 当前页面显示的内容
     this.changePage(this.currentPage)
    },
    
    changePage (page) {
      this.currentPage = page
      this.isPC ? (this.dataList = this.totalDataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)) : (this.dataList = this.totalDataList)
    },
    showDetail (item) {
      if (item.worksName) {
        // A, F
        if (item.boothNo.indexOf('F') >= 0) {
          this.subpath = 'star'
          this.detail = item.boothNo
        } else if (item.boothNo.indexOf('A') >= 0) {
          this.subpath = 'achievement'
          this.detail = item.boothNo
        } else if (item.showVideoName) {
          this.subpath = 'show'
          this.detail = item.boothNo
        }
      } else {
        // B C D E
        if (item.boothNo.indexOf('B') >= 0) {
          this.subpath = 'edu'
          this.detail = item.boothNo
        } else if (item.boothNo.indexOf('C') >= 0) {
          this.subpath = 'station'
          this.detail = item.boothNo
        } else if (item.boothNo.indexOf('D') >= 0) {
          this.subpath = 'exam'
          this.detail = item.boothNo
        } else if (item.boothNo.indexOf('E') >= 0) {
          this.subpath = 'company'
          this.detail = item.boothNo
        }
      }
    }
  }
}
</script>

<style scoped>
  .content-area {
    width:100%;
    min-height: 400px;
    padding-top:2rem;
  }
  .list-wrapper {
    width: 80rem;
    margin: 0 auto;
  }
  h3 {
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
  .list-item {
    vertical-align: top;
    display: block;
    border-bottom: 1px solid #ff942c;
  }
  .item-des {
    padding: 1.2rem 0;
    font-size: 1.6rem;
    color: #fff;
    cursor: pointer;
  }
  /* mobile */
  .m-content-area {
    width:100%;
    height: 100%;
    padding-top: 10px;
  }
  .m-list-wrapper {
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    text-align: center;
  }
  .m-list-wrapper .list-item {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
    text-align: left;
  }
  .m-list-wrapper .item-des {
    line-height:1.5;
    height: 40px;
    font-size: 14px;
    text-align: left;
  }
</style>